import { useFeatureFlag } from '@/scopes/common/infrastructure/feature-flags'

import { CustomerRatingFilter } from '@/scopes/search/search/pages/SearchPage/components/Filters/CustomerRatingFilter'
import {
  DistanceFilters,
} from '@/scopes/search/search/pages/SearchPage/components/Filters/DistanceFilters/DistanceFilters'

import { FacilitiesFilter } from '@/scopes/search/search/pages/SearchPage/components/Filters/FacilitiesFilter'
import { PricePerPersonFilter } from '@/scopes/search/search/pages/SearchPage/components/Filters/PricePerPersonFilter'
import { TransportTypeFilter } from '@/scopes/search/search/pages/SearchPage/components/Filters/TransportTypeFilter'
import { AccommodationTypeFilter } from './AccommodationTypeFilter'
import { AirlineFilter } from './AirlineFilter'
import { CampaignsAndDiscountsFilter } from './CampaignsAndDiscountsFilter'
import { CollectionsFilter } from './CollectionsFilter'
import { DestinationFilter } from './DestinationFilter'
import { IntelligentFilter } from './IntelligentFilter'
import { LastMinuteFilter } from './LastMinuteFilter'
import { MealPlanFilter } from './MealPlanFilter'
import { NumberOfRoomsFilter } from './NumberOfRoomsFilter'
import { StarsFilter } from './StarsFilter'
import { VacationTypeFilter } from './VacationTypeFilter'

export function SummerFilters() {
  const isAirlineFilterEnabled = useFeatureFlag('BAHAMAS_ENABLE_AIRLINE_FILTER')
  return (
    <>
      <IntelligentFilter defaultOpen />
      <DestinationFilter defaultOpen />
      <PricePerPersonFilter defaultOpen />
      <TransportTypeFilter defaultOpen />
      {isAirlineFilterEnabled && <AirlineFilter defaultOpen />}
      <AccommodationTypeFilter defaultOpen />
      <MealPlanFilter defaultOpen />
      <CampaignsAndDiscountsFilter />
      <FacilitiesFilter />
      <StarsFilter />
      <DistanceFilters />
      <CustomerRatingFilter />
      <VacationTypeFilter />
      <LastMinuteFilter />
      <NumberOfRoomsFilter />
      <CollectionsFilter />
    </>
  )
}
